/**
 * @file The closed list of Analytics page tabs, in display order. Consumers:
 * `analyticsView`, which falls back to the first tab for any other `tab`
 * value, and `ANALYTICS_TAB_QUERIES`. Each later tab is appended here and
 * given its queries there. The disabled Explore tab is not listed, so a
 * `?tab=explore` URL falls back to the first tab.
 */
export const ANALYTICS_TABS = [
  'overview',
  'projects',
  'orders',
  'invoicing',
  'reports',
  'metrics',
] as const;
